import React from 'react';
import eventServices from '../data/eventServices';

export default function EventServices() {
  return (
    <section className="py-12">
      <h3 className="text-3xl font-extrabold tracking-tight mb-8">Professional Event Services</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {eventServices.map((svc) => (
          <div key={svc.id} className="bg-white rounded-2xl overflow-hidden border border-[#e7e3cf] group hover:shadow-xl transition-all">
            <div className="h-64 relative overflow-hidden">
              <img alt={svc.category} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" src={svc.img} />
              <div className="absolute top-4 left-4 bg-primary text-white px-4 py-1.5 rounded-full text-xs font-bold shadow-md">{svc.category}</div>
            </div>
            <div className="p-8">
              <div className="flex justify-between items-center mb-3">
                <h4 className="text-2xl font-bold">{svc.title}</h4>
                <div className="flex items-center gap-1 text-primary">
                  <span className="material-symbols-outlined !text-xl">star</span>
                  <span className="text-lg font-bold">{svc.rating}</span>
                </div>
              </div>
              <p className="text-[#9a8d4c] text-sm mb-6 leading-relaxed">{svc.description}</p>
              <div className="flex items-center justify-between pt-6 border-t border-[#f3f1e7]">
                <div>
                  <p className="text-[10px] text-[#9a8d4c] font-bold uppercase">Base Price</p>
                  <p className="text-2xl font-black">{svc.price}<span className="text-sm font-normal text-[#9a8d4c]">{svc.pricePeriod}</span></p>
                </div>
                <button className="bg-primary text-white px-8 py-3 rounded-xl font-bold hover:bg-gold-dark transition-all shadow-md">Book Now</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
